import * as z from "zod";
export var userSignInModalSchema = z.object({
    email: z
        .string()
        .min(1, { message: "Email is required." })
        .email({ message: "Please enter a valid email address." }),
    password: z.string().optional(),
});
